// extracted by mini-css-extract-plugin
module.exports = {"product-tabs":"MobileProductTabs_product-tabs__MFvQB","productItem":"MobileProductTabs_productItem__SfQiG","active":"MobileProductTabs_active__4q_w6"};